var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.15596C3.77243 1.15596 1.15596 3.77243 1.15596 7C1.15596 10.2276 3.77243 12.844 7 12.844C10.2276 12.844 12.844 10.2276 12.844 7C12.844 3.77243 10.2276 1.15596 7 1.15596ZM0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM7 2.56881C7.31921 2.56881 7.57798 2.82758 7.57798 3.14679V6.64279L9.82729 7.76744C10.1128 7.9102 10.2285 8.25737 10.0858 8.54289C9.94302 8.8284 9.59584 8.94412 9.31033 8.80137L6.74152 7.51696C6.54571 7.41906 6.42202 7.21892 6.42202 7V3.14679C6.42202 2.82758 6.68079 2.56881 7 2.56881Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f936c94dfc4476d684f24e80f1cc6a5f.svg";
export { ForwardRef as ReactComponent };